import { AddressViewModel, CreatePersonAddressCommand, UpdatePersonAddressCommand } from '../../models/Entities/Person/Address/AddressModels';
import { ErrorType } from '../../models/HttpError';

export const PERSON_ADDRESS_GETALL_REQUEST = 'PERSON_ADDRESS_GETALL_REQUEST';
export const PERSON_ADDRESS_GETALL_SUCCESS = 'PERSON_ADDRESS_GETALL_SUCCESS';
export const PERSON_ADDRESS_GETALL_FAILURE = 'PERSON_ADDRESS_GETALL_FAILURE';

export interface PersonAddressGetAllRequestAction {
    type: typeof PERSON_ADDRESS_GETALL_REQUEST;
    personId: number;
}

export interface PersonAddressGetAllSuccessAction {
    type: typeof PERSON_ADDRESS_GETALL_SUCCESS;
    personId: number;
    payload: AddressViewModel[];
}

export interface PersonAddressGetAllFailureAction {
    type: typeof PERSON_ADDRESS_GETALL_FAILURE;
    error: ErrorType;
}

export const PERSON_ADDRESS_GETBYID_REQUEST = 'PERSON_ADDRESS_GETBYID_REQUEST';
export const PERSON_ADDRESS_GETBYID_SUCCESS = 'PERSON_ADDRESS_GETBYID_SUCCESS';
export const PERSON_ADDRESS_GETBYID_FAILURE = 'PERSON_ADDRESS_GETBYID_FAILURE';

export interface PersonAddressGetByIdRequestAction {
    type: typeof PERSON_ADDRESS_GETBYID_REQUEST;
    id: number;
}

export interface PersonAddressGetByIdSuccessAction {
    type: typeof PERSON_ADDRESS_GETBYID_SUCCESS;
    payload: AddressViewModel;
}

export interface PersonAddressGetByIdFailureAction {
    type: typeof PERSON_ADDRESS_GETBYID_FAILURE;
    error: ErrorType;
}

export const PERSON_ADDRESS_CREATE_REQUEST = 'PERSON_ADDRESS_CREATE_REQUEST';
export const PERSON_ADDRESS_CREATE_SUCCESS = 'PERSON_ADDRESS_CREATE_SUCCESS';
export const PERSON_ADDRESS_CREATE_FAILURE = 'PERSON_ADDRESS_CREATE_FAILURE';

export interface PersonAddressCreateRequestAction {
    type: typeof PERSON_ADDRESS_CREATE_REQUEST;
    payload: CreatePersonAddressCommand;
}

export interface PersonAddressCreateSuccessAction {
    type: typeof PERSON_ADDRESS_CREATE_SUCCESS;
    payload: AddressViewModel;
}

export interface PersonAddressCreateFailureAction {
    type: typeof PERSON_ADDRESS_CREATE_FAILURE;
    error: ErrorType;
}

export const PERSON_ADDRESS_UPDATE_REQUEST = 'PERSON_ADDRESS_UPDATE_REQUEST';
export const PERSON_ADDRESS_UPDATE_SUCCESS = 'PERSON_ADDRESS_UPDATE_SUCCESS';
export const PERSON_ADDRESS_UPDATE_FAILURE = 'PERSON_ADDRESS_UPDATE_FAILURE';

export interface PersonAddressUpdateRequestAction {
    type: typeof PERSON_ADDRESS_UPDATE_REQUEST;
    payload: UpdatePersonAddressCommand;
}

export interface PersonAddressUpdateSuccessAction {
    type: typeof PERSON_ADDRESS_UPDATE_SUCCESS;
    payload: AddressViewModel;
}

export interface PersonAddressUpdateFailureAction {
    type: typeof PERSON_ADDRESS_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const PERSON_ADDRESS_DELETE_REQUEST = 'PERSON_ADDRESS_DELETE_REQUEST';
export const PERSON_ADDRESS_DELETE_SUCCESS = 'PERSON_ADDRESS_DELETE_SUCCESS';
export const PERSON_ADDRESS_DELETE_FAILURE = 'PERSON_ADDRESS_DELETE_FAILURE';

export interface PersonAddressDeleteRequestAction {
    type: typeof PERSON_ADDRESS_DELETE_REQUEST;
    id: number;
}

export interface PersonAddressDeleteSuccessAction {
    type: typeof PERSON_ADDRESS_DELETE_SUCCESS;
    id: number;
}

export interface PersonAddressDeleteFailureAction {
    type: typeof PERSON_ADDRESS_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}
